import React, { useState } from 'react'
import Button from '@global/Button'
import { Link } from '@routes'
import { resetPassword } from '@lib/api-services/authService'
import * as S from './Login.styled'

const InstructionSent = ({ title, text, emailResend }) => {
  const [resendSubmitted, setsendSubmitted] = useState(false)

  const resend = async () => {
    if (resendSubmitted) return
    await resetPassword(emailResend)
    setsendSubmitted(true)
  }

  return (
    <S.FormContainer>
      <S.ContainerLeft>
        <S.Title>{title}</S.Title>
        <S.Description dangerouslySetInnerHTML={{ __html: text }} />
      </S.ContainerLeft>

      <S.ContainerRight>
        <S.Form>
          <S.FormGroup>
            <Link route='/login' passHref>
              <Button color='secondary' style={{ width: '100%' }}>
                Back to Login
              </Button>
            </Link>
            <Link route='/' passHref>
              <Button border color='secondary' style={{ width: '100%' }}>
                Head Home
              </Button>
            </Link>
          </S.FormGroup>
          <S.SubActionContainer>
            <S.TextLink>Didn&apos;t receive an email?</S.TextLink>{' '}
            <S.Resend size='small' onClick={() => resend()}>
              {resendSubmitted ? 'Sent' : 'Resend'}
            </S.Resend>
          </S.SubActionContainer>
        </S.Form>
      </S.ContainerRight>
    </S.FormContainer>
  )
}

InstructionSent.defaultProps = {
  title: 'Instructions Sent',
  text: `Check your inbox, as we've just sent an email with instructions on how to reset your password to your nominated email address.
    <br /><br />
    Please note, for your own security, the password reset link in this email will expire after 24 hours.`,
}

export default InstructionSent
